"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axeDefaultConfig = void 0;
exports.axeDefaultConfig = {
    resultTypes: ['violations', 'incomplete'],
    runOnly: [
        'wcag2a',
        'wcag2aa',
        'wcag21a',
        'wcag21aa',
        'best-practice',
        'wcag22aa',
    ],
    rules: {
        'color-contrast': { enabled: false },
    },
};
